import { c as _c } from "react/compiler-runtime";
import { X } from 'lucide-react';
const ErrorMessage = t0 => {
  const $ = _c(3);
  const {
    message
  } = t0;
  if (!message) {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <X className="w-4 h-4 text-destructive" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== message) {
    t2 = <div className="flex items-center gap-1">{t1}<p className="text-sm font-medium text-destructive">{message}</p></div>;
    $[1] = message;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
export default ErrorMessage;